if (!customElements.get("video-block")) {
  customElements.define(
    "video-block",
    class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.videoType) return;
        this.querySelector(".split-section__video-cover").addEventListener("click", () =>
          this._play(),
        );
      }

      _play() {
        const cover = this.querySelector(".split-section__video-cover");
        const embed = this.querySelector(".split-section__video-embed");
        const { videoType, youtubeId, shopifyVideo } = this.dataset;

        if (videoType === "youtube") {
          embed.innerHTML = `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
        } else if (videoType === "shopify") {
          embed.innerHTML = `<video src="${shopifyVideo}" autoplay controls playsinline></video>`;
        }

        cover.hidden = true;
        embed.removeAttribute("hidden");
      }
    },
  );
}
